import { Component, OnDestroy } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { BaseComponent, Grid } from '../../shared'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { GridSelectionCalculationComponent } from '../../shared/reusable-components/grid-selection-calculation/grid-selection-calculation.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'

@Component({
    templateUrl: './firm-contacts.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarSearchComponent,
        GridExportComponent,
        WjInputModule,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
        GridSelectionCalculationComponent,
    ],
})
export class FirmContactsComponent extends BaseComponent implements OnDestroy {
    firmsGrid: Grid<any>
    private filterChangedHandler: () => void

    constructor() {
        super()
        this.firmsGrid = new Grid<any>(this.services)
            .wrapColumnHeaders()
            .filterBy(item => [item.name, item.code1, item.code2, item.code3, item.code4, item.code5])

        // Subscribe to filter changes to collapse groups when filtering occurs
        this.filterChangedHandler = this.firmsGrid.filterChanged.on(() => {
            if (this.firmsGrid.flexGrid) {
                this.firmsGrid.flexGrid.collapseGroupsToLevel(0)
            }
        })

        this.refresh()
    }

    ngOnDestroy(): void {
        this.firmsGrid.filterChanged.off(this.filterChangedHandler)
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data.load(true, true, this.services.data.get('/api/VpOwner/GetFirms')).subscribe({
                next: result => {
                    this.initialLoadingComplete()
                    const firms = result[0]

                    // We need to go through all the contacts on the firms and combine the first and last name into the contactName property.
                    for (const firm of firms) {
                        for (const contact of firm.contacts) {
                            contact.contactName = contact.firstName + ' ' + contact.lastName
                        }
                    }

                    this.firmsGrid.items = firms
                    this.firmsGrid.flexGrid.collapseGroupsToLevel(0)
                },
            }),
        )
    }
}
